export default "/images/8ebd553410121fe426e0cadb7a0443a4.png";